import { ModalServiceInterface } from 'pf-frontend-common/src/service/modal/service.interface';

import { ViewDynamicInterface } from 'common/module/view/dynamic.interface';
import { BuildingReviewFormViewOptionsInterface } from 'desktop/module/building-review/form/view-options.interface';
import { BuildingReviewFormViewStore } from 'desktop/module/building-review/form/view-store';
import { BuildingReviewFormViewStoreEvent } from 'desktop/module/building-review/form/view-store.event';

/**
 * Building review modal and form
 */
export class BuildingReviewFormView {
  /**
   * View html element
   */
  private element: HTMLElement;

  /**
   * Constructor
   */
  constructor(
    private modalService: ModalServiceInterface,
    private viewDynamic: ViewDynamicInterface<BuildingReviewFormViewStore>
  ) {}

  /**
   * Initialize form
   */
  public initialize(options: BuildingReviewFormViewOptionsInterface): void {
    this.element = options.element;

    this.viewDynamic.getViewStore().initialize({
      hasAutocomplete: options.hasAutocomplete,
    });

    this.viewDynamic.getViewStore().updateLocation(options.location.id, options.location.name);

    this.viewDynamic
      .getViewStore()
      .getEventEmitter()
      .addListener(BuildingReviewFormViewStoreEvent.close, this.onCloseViewStore);

    this.viewDynamic.initialize({
      element: options.element,
    });
  }

  /**
   * Render form
   */
  public render(): void {
    this.viewDynamic.render();
  }

  /**
   * Set the open state of the building review form modal
   */
  public setOpen(isOpen: boolean): void {
    if (isOpen) {
      this.modalService.getContentElement().innerHTML = '';
      this.modalService.getContentElement().appendChild(this.element);
      this.render();
      this.modalService.open();
    } else {
      this.modalService.getContentElement().innerHTML = '';
      this.modalService.close();
    }
  }

  /**
   * Closed form
   */
  private onCloseViewStore = () => {
    // Reset form state if form send is successful
    if (this.viewDynamic.getViewStore().getState().action === 'send-success') {
      this.viewDynamic.getViewStore().resetState();
    }

    this.setOpen(false);
  };
}
